import { Link, useNavigate } from "react-router-dom";
import { App, Button, Layout, Space, Spin, Typography } from "antd";
import { hasCurrentIdCheck, idVerificationFreshness } from "@gull/shared";
import { useAuth } from "../../lib/auth";
import { useProfile } from "../../lib/useProfile";
import BestillPoseWizard from "./BestillPoseWizard";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function BestillPose() {
  const { user, loading, signInWithVipps } = useAuth();
  const { message } = App.useApp();
  const navigate = useNavigate();

  const profile = useProfile(user?.uid);

  if (loading) {
    return (
      <Content style={{ padding: 48 }}>
        <Spin />
      </Content>
    );
  }

  if (!user) {
    return (
      <Content style={{ maxWidth: 480, margin: "64px auto", padding: 24 }}>
        <div className="sendin-auth-card">
          <Title level={2}>Bestill gullkonvolutt</Title>
          <Paragraph>Logg inn med Vipps for å bestille en gullkonvolutt.</Paragraph>
          <Button
            className="vipps-button"
            type="primary"
            size="large"
            block
            onClick={signInWithVipps}
          >
            Logg inn med Vipps
          </Button>
        </div>
      </Content>
    );
  }

  // The server refuses the order on the same rule, so the page stops here rather than after the form.
  if (profile && !hasCurrentIdCheck(profile)) {
    const expired = idVerificationFreshness(profile) === "expired";
    return (
      <Content style={{ maxWidth: 560, margin: "64px auto", padding: 24 }}>
        <div className="sendin-auth-card">
          <Title level={2}>{expired ? "ID-bekreftelsen er utløpt" : "ID må bekreftes først"}</Title>
          {expired ? (
            <Paragraph>
              En ID-bekreftelse gjelder i ett år. Logg inn med Vipps på nytt for å fornye
              automatisk, eller ta med pass / førerkort / nasjonalt ID-kort i butikk for å fornye.
            </Paragraph>
          ) : (
            <Paragraph>
              For å sende deg en gullkonvolutt i posten må vi ha bekreftet identiteten din. Logg inn
              med Vipps for å fullføre dette automatisk, eller møt opp i butikk med pass / førerkort
              / nasjonalt ID-kort.
            </Paragraph>
          )}
          <Space>
            <Button className="vipps-button" type="primary" onClick={signInWithVipps}>
              Bekreft med Vipps
            </Button>
            <Link to="/min-side">
              <Button>Min side</Button>
            </Link>
          </Space>
        </div>
      </Content>
    );
  }

  return (
    <Content className="sendin-page">
      <Link to="/min-side" className="sendin-back-link">
        ← Min side
      </Link>
      <h1 className="sendin-title">Selg gull til oss</h1>
      <p className="sendin-subtitle">Bestill gullkonvolutt hjem</p>

      <BestillPoseWizard
        user={user}
        profile={profile}
        onSubmitted={(result) => {
          message.success(`Gullkonvolutt bestilt — kvitteringskode ${result.receiptCode}`);
          navigate("/min-side?seksjon=deliveries", { replace: true });
        }}
      />
    </Content>
  );
}
